import React, { useEffect, useState } from "react";
import axios from "axios";
import VerticalBarChart from "../../components/VerticalBarChart";
import ImageLoading from "../../components/ImageLoading";

const UsageNew = () => {
  const [activeHeading, setActiveHeading] = useState([
    true,
    false,
    false,
    // false,
  ]);

  // aa, vehicle, salary, mutual_fund_ltv, digio_kyc,cams_fetch, cams_pledge, cams_invoke, cams_revoke, digisign, easebuzz_mandate, easebuzz_disbursal,vehicle_challan,eazebuzz_emi, total_assets
  const [activeAssetList, setActiveAssetList] = useState([
    "One money",
    "NSDL",
    "Vehicle",
    "Salary",
    "Mutual fund LTV",
    "Digio KYC",
    "CAMS fetch",
    "CAMS pledge",
    "CAMS invoke",
    "CAMS revoke",
    "Digisign",
    "Easebuzz mandate",
    "Easebuzz disbursal",
    "Easebuzz EMI",
    "Vehicle challan",
  ]);
  const [activeAsset, setActiveAsset] = useState("One money");
  const [duration, setDuration] = useState("yearly");
  const [graphData, setGraphData] = useState();
  const [totalHits, setTotalHits] = useState("");
  const [selectedAssetHits, setSelectedAssetHits] = useState("");
  const [loading, setLoading] = useState(false);

  const handleActiveHeading = (index) => {
    const temArr = activeHeading.map(() => false);
    temArr[index] = true;
    setActiveHeading(temArr);
  };

  const handleActiveAsset = (e) => {
    setActiveAsset(e.target.value);
  };

  useEffect(() => {
    const getDetails = async () => {
      setLoading(true);
      const lender_id = localStorage.getItem("lender_id");
      const token = localStorage.getItem("token");
      const options = {
        url: `${
          process.env.REACT_APP_URL
        }/lender/fetch_api_hits?duration=${duration}&lender_id=${lender_id}&asset_name=${activeAsset
          .toLowerCase()
          ?.split(" ")
          .join("_")}`,
        method: "GET",
        headers: { Authorization: token },
      };
      try {
        const res = await axios(options);
        setGraphData(res.data.data.dates);
        setTotalHits(res.data.data.total_assets_hits);
        setSelectedAssetHits(res.data.data.total_selected_asset_hits);
        setLoading(false);

        // console.log(res);
      } catch (error) {
        console.log(error);
      }
    };

    getDetails();
  }, [activeAsset, duration]);

  const graphLabels = graphData && Object.keys(graphData);
  const graphValues = graphData && Object.values(graphData);

  return (
    // <div className="employees">
    <div className="employees-wrap  mt-4  " style={{ borderStyle: "none" }}>
      {/* usage box */}
      <div className="usage-box">
        {/* <h1>Usage</h1> */}
        <p style={{ marginTop: "5px" }}>
          Below is a summary of your API usage.
        </p>
        {/* boxes */}
        <div className="usage-number-boxes">
          <div>
            <p className="text-sm font-medium leading-6 text-gray-500">
              Total API hits
            </p>
            <p
              className={`w-full flex-none text-3xl font-medium leading-10 tracking-tight text-gray-900 ${
                loading ? "text-lg" : ""
              }`}
            >
              {loading ? "Loading..." : totalHits}
            </p>
            {/* <p className="box-others">View Breakdown</p> */}
          </div>
          <div>
            <p className="text-sm font-medium leading-6 text-gray-500">
              {activeAsset === "total_assets" ? "All assets" : activeAsset} API
              hits
            </p>
            <p
              className={`w-full flex-none text-3xl font-medium leading-10 tracking-tight text-gray-900 ${
                loading ? "text-lg" : ""
              }`}
            >
              {loading ? (
                <>Loading...</>
              ) : (
                <>
                  {activeAsset === "total_assets"
                    ? totalHits
                    : selectedAssetHits}
                </>
              )}
            </p>
            {/* <p className="box-others">View Breakdown</p> */}
          </div>
          {/* <div>
              <p className="box-heading">Available API credits</p>
              <p className="box-value">INR 10,000</p>
              <p className="box-others buy-now-btn">Buy now</p>
            </div> */}
        </div>
      </div>
      {/* usage graph */}
      <div className="usage-graph">
        <div className="graph-details">
          <div className="from-to-container">
            <select
              onChange={(e) => handleActiveAsset(e)}
              className={
                activeAssetList.includes(activeAsset)
                  ? "select-asset active-asset"
                  : "select-asset"
              }
            >
              {activeAssetList.map((i) => (
                <option value={i} selected={i === activeAsset}>
                  {i}
                </option>
              ))}
            </select>
            <button
              onChange={(e) => handleActiveAsset(e)}
              className={
                activeAsset === "total_assets"
                  ? "select-asset active-asset"
                  : "select-asset"
              }
              onClick={() => setActiveAsset("total_assets")}
            >
              All assets
            </button>
          </div>
          <div className="year-month-switch-container">
            {/* <div
              className={activeHeading[0] ? "active-heading" : "normal-heading"}
              onClick={() => {
                handleActiveHeading(0);
                setDuration("weekly");
              }}
            >
              <p>Daily</p>
            </div> */}
            {/* <div
              className={activeHeading[1] ? "active-heading" : "normal-heading"}
              onClick={() => {
                handleActiveHeading(1);
                setDuration("monthly");
              }}
            >
              <p>Monthly</p>
            </div> */}
            {/* <div
              className={activeHeading[2] ? "active-heading" : "normal-heading"}
              onClick={() => {
                handleActiveHeading(2);
                setDuration("yearly");
              }}
            >
              <p>Yearly</p>
            </div> */}
            {/* <div
                className={
                  activeHeading[3] ? "active-heading" : "normal-heading"
                }
                onClick={() => {
                  handleActiveHeading(3);
                  setDuration("cumulative");
                }}
              >
                <p>Cumulative</p>
              </div> */}
          </div>
        </div>
        {loading && (
          <div className="w-full h-[calc(100vh-400px)] flex justify-center items-center">
            <ImageLoading />
          </div>
        )}
        {!loading && (
          <div className="graph">
            {graphData && (
              <VerticalBarChart
                graphLabels={graphLabels}
                graphValues={graphValues}
              />
            )}
          </div>
        )}
      </div>
    </div>
    // </div>
    // <>
    //   <ContentLoader width={200} height={200} viewBox="0 0 200 200">
    //     <rect x="0" y="160" rx="0" ry="0" width="25" height="40" />
    //     <rect x="30" y="145" rx="0" ry="0" width="25" height="55" />
    //     <rect x="60" y="126" rx="0" ry="0" width="25" height="74" />
    //     <rect x="90" y="80" rx="0" ry="0" width="25" height="120" />
    //     <rect x="120" y="142" rx="0" ry="0" width="25" height="58" />
    //   </ContentLoader>
    // </>
  );
};

export default UsageNew;
